var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0 15px"},on:{"click":_vm.toggleClick}},[_c('div',{staticClass:"hamburger",class:{ 'is-active': _vm.isActive }},[_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":"shouqi"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }